import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDnHFUdF_nUSFFoGKn2nSzT_v1lFnSqq0A",
  authDomain: "stationcab-3db87.firebaseapp.com",
  projectId: "stationcab-3db87",
  storageBucket: "stationcab-3db87.firebasestorage.app",
  messagingSenderId: "273482706345",
  appId: "1:273482706345:web:83bae995d96eaca393a8b8"
};

const app = initializeApp(firebaseConfig);

let messaging = null;

if (typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.log('Firebase messaging not supported:', error);
  }
}

export const requestNotificationPermission = async () => {
  if (!messaging) return null;
  
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: "BDYjBmadUpWn5a2-Kf3f_2UxUII9aMwi9_eCLEM7DknEvz95GvnEkBAQgVC9hhKrZvJeEt74pLFLS9Ntspjwnrk"
      });
      console.log('FCM Token:', token);
      return token;
    }
    return null;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

export const onMessageListener = () => {
  if (!messaging) return Promise.resolve(null);
  
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};

export { messaging };
